import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import axiosInstance from '@/api/axiosInstance'

const PAYMENT_REQUESTS_PATH = '/payment-requests/'
const PAYMENT_METHODS_PATH = '/payment-requests/payment_methods/'

export const usePaymentMethods = () => {
    return useQuery({
        queryKey: ['payment-methods'],
        queryFn: async () => {
            const response = await axiosInstance.get(PAYMENT_METHODS_PATH)
            return response.data
        },
        staleTime: 60 * 60 * 1000,
    })
}

export const usePaymentRequests = () => {
    return useQuery({
        queryKey: ['payment-requests'],
        queryFn: async () => {
            const response = await axiosInstance.get(PAYMENT_REQUESTS_PATH)
            return response.data.results || response.data
        },
        staleTime: 30 * 1000,
    })
}

export const useSubmitPayment = () => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: async (data: {
            service_request: number
            amount: number
            payment_method: string
            receipt_image_url: string
        }) => {
            const response = await axiosInstance.post(
                `/service-requests/${data.service_request}/submit_payment/`,
                data
            )
            return response.data
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['payment-requests'] })
            queryClient.invalidateQueries({ queryKey: ['service-requests'] })
        },
    })
}

export const useResubmitPayment = () => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: async (data: { id: number; receipt_image_url: string }) => {
            const response = await axiosInstance.post(
                `${PAYMENT_REQUESTS_PATH}${data.id}/resubmit/`,
                { receipt_image_url: data.receipt_image_url }
            )
            return response.data
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['payment-requests'] })
        },
    })
}


